import env from 'env';
import { Review } from '../types/review.type';

export const getReviewSiteUrl = (
  review: Review,
  proViewId?: number,
): string => {
  const view = review.referenceView?.view;

  return proViewId
    ? `${env.SITE_URL}/pro/fiche/${proViewId}#reviews`
    : `${env.SITE_URL}/presentations/${view?.id}-${view?.proPresentation.slug}#reviews`;
};
